import { makeChartComp } from '../../util/makeChartComp';
var VennChart = makeChartComp('Venn');
export default VennChart;
